import API from "./axios";

export const getCustomers = async () => {
  try {
    const response = await API.get("/customer");
    return response.data;
  } catch (error) {
    throw error.response.data.message || "Failed to fetch customers";
  }
};

export const createCustomer = async (customerData) => {
  try {
    // Check if any attachments are files
    const hasFiles = Object.keys(customerData).some(key => key.startsWith('attachments_') && customerData[key] instanceof File);

    if (hasFiles) {
      // Use FormData for file uploads
      const formData = new FormData();
      Object.keys(customerData).forEach(key => {
        if (customerData[key] !== null && customerData[key] !== undefined) {
          formData.append(key, customerData[key]);
        }
      });

      const response = await API.post("/customer", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } else {
      // Use regular JSON for non-file data
      const response = await API.post("/customer", customerData);
      return response.data;
    }
  } catch (error) {
    throw error.response.data.message || "Failed to create customer";
  }
};

export const createCustomerWithPayment = async (customerData, paymentMethod) => {
  try {
    // Check if any attachments are files
    const hasFiles = Object.keys(customerData).some(key => key.startsWith('attachments_') && customerData[key] instanceof File);

    if (hasFiles) {
      // Use FormData for file uploads
      const formData = new FormData();
      Object.keys(customerData).forEach(key => {
        if (customerData[key] !== null && customerData[key] !== undefined) {
          formData.append(key, customerData[key]);
        }
      });
      formData.append('paymentMethod', paymentMethod);

      const response = await API.post("/customer/with-payment", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } else {
      // Use regular JSON for non-file data
      const response = await API.post("/customer/with-payment", { ...customerData, paymentMethod });
      return response.data;
    }
  } catch (error) {
    throw error.response.data.message || "Failed to create customer with payment";
  }
};

export const updateCustomer = async (id, customerData) => {
  try {
    // Check if any attachments are files
    const hasFiles = Object.keys(customerData).some(key => key.startsWith('attachments_') && customerData[key] instanceof File);
    console.log("update customer hasFiles", hasFiles);
    if (hasFiles) {
      // Use FormData for file uploads
      const formData = new FormData();
      Object.keys(customerData).forEach(key => {
        if (customerData[key] !== null && customerData[key] !== undefined) {
          formData.append(key, customerData[key]);
        }
      });

      const response = await API.put(`/customer/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } else {
      // Use regular JSON for non-file data
      const response = await API.put(`/customer/${id}`, customerData);
      return response.data;
    }
  } catch (error) {
    throw error.response.data.message || "Failed to update customer";
  }
};

export const sendCustomersToSubadmin = async (customersWithYears, razorpayOrderId) => {
  try {
    const response = await API.post("/customer/send-to-subadmin", { customersWithYears, razorpayOrderId });
    return response.data;
  } catch (error) {
    throw error.response.data.message || "Failed to send customers to subadmin";
  }
};

export const getSentCustomers = async () => {
  try {
    const response = await API.get("/customer/sent-to-subadmin");
    return response.data;
  } catch (error) {
    throw error.response.data.message || "Failed to fetch sent customers";
  }
};

export const checkDuplicatePan = async (panNumber) => {
  try {
    const response = await API.get(`/customer/check-pan/${panNumber}`);
    return response.data;
  } catch (error) {
    console.error("Error checking checkDuplicatePan:", error);
    throw error.response?.data?.message || "Failed to check PAN";
  }
};

export const importCustomers = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await API.post("/customer/import", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || error.response?.data?.message || "Failed to import customers";
  }
};
